import { render, staticRenderFns } from "./CookiePolicyPage.vue?vue&type=template&id=0eee3365&scoped=true&"
import script from "./CookiePolicyPage.vue?vue&type=script&lang=js&"
export * from "./CookiePolicyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0eee3365",
  null
  
)

export default component.exports